import type { STORAGE_TYPES } from '@sites/constants/generic';

type StorageTypes = (typeof STORAGE_TYPES)[keyof typeof STORAGE_TYPES];

const isStorageSupported = (type: StorageTypes) => {
  try {
    const storage = window[type];
    storage.setItem('test-key', 'test-value');
    storage.getItem('test-key');
    storage.removeItem('test-key');
    return true;
  } catch (e) {
    return false;
  }
};

const memoryStorage = {
  cache: {} as Record<string, string>,
  setItem(cacheKey: string, data: string) {
    this.cache[cacheKey] = data;
  },
  getItem(cacheKey: string) {
    return this.cache[cacheKey];
  },
  removeItem(cacheKey: string) {
    delete this.cache[cacheKey];
  },
};

const getStorage = (type: StorageTypes) => {
  if (isStorageSupported(type)) {
    return window[type];
  }
  return memoryStorage;
};

export default getStorage;
